import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import {
  updatePublishProduct,
  getPublishingProductsById,
} from "../../services/axios";
import { Link } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const Product = (props) => {
  let [product, setProduct] = useState(null);

  let history = useHistory();
  let PID = props.match.params.id;

  useEffect(() => {
    const fetchProduct = async (PID) => {
      const result = await getPublishingProductsById(PID);
      console.log("result", result);
      setProduct(result);
    };
    fetchProduct(PID);
  }, [PID]);

  function goBack() {
    history.push({
      pathname: `/campaign/${product.campaign}`,
    });
  }

  function goToDesign(design) {
    history.push({
      pathname: `/design?sort=${design}`,
    });
  }

  let statusMenu = [
    { status: "review" },
    { status: "start" },
    { status: "complete" },
  ];

  const handleStatusChange = (item) => {
    return updatePublishProduct({ id: PID, status: item.status });
  };

  function StatusPicker() {
    return (
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100">
            Options
            <ChevronDownIcon
              className="-mr-1 ml-2 h-5 w-5"
              aria-hidden="true"
            />
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              {statusMenu.map(function (item, index) {
                return (
                  <Menu.Item key={index}>
                    {({ active }) => (
                      <button
                        onClick={() => handleStatusChange(item)}
                        className={classNames(
                          active
                            ? "bg-gray-100 text-gray-900"
                            : "text-gray-700",
                          "block px-4 py-2 text-sm text-left"
                        )}
                      >
                        {item.status}
                      </button>
                    )}
                  </Menu.Item>
                );
              })}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    );
  }

  function VariantList() {
    return product.variants.map(function (v, index) {
      return (
        <div key={index} className="p-16 border rounded flex flex-row">
          <div className="w-full">
            <p>brand: {v.brand}</p>
            <p>mode: {v.model}</p>
            <p>sku: {v.sku}</p>
            <p>color: {v.color}</p>
            <p>price: {v.price}</p>
            <p>size: {v.size}</p>
            <p>view: {v.view}</p>
            <p>job: {v.job}</p>
            <p>position: {v.position}</p>
          </div>
          <div className="w-1/2">
            <img className="object-fit" src={v.proof} />
          </div>
        </div>
      );
    });
  }

  function getVariantCount() {
    if (product.variants && product.variants.length > 0) {
      let assets = product.variants.map(function (variant) {
        return {
          brand: variant.brand,
          model: variant.model,
          sku: variant.sku,
          color: variant.color,
          size: variant.size,
        };
      });
      let removeDuplicates = assets.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              t.brand === value.brand &&
              t.model === value.model &&
              t.sku === value.sku &&
              t.color === value.color &&
              t.size === value.size
          )
      );
      return removeDuplicates.length;
    } else {
      return 0;
    }
  }

  const getLicensorName = (licensor) => {
    switch (licensor) {
      case "affinity":
        return "Affinity";
      case "nonaffinity":
        return "CLC";
      case "brandr":
        return "BrandR";
      case "exemplar":
        return "Exemplar";
      default:
        return "unknown";
    }
  };

  return (
    <div className="m-8">
      {product && (
        <div>
          <div
            className="underline cursor-pointer text-deeppurple mb-10"
            onClick={() => goBack(product.campaign)}
          >
            Back to Campaign
          </div>
          <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Campaign Details
              </h3>
              <div className="grid grid-cols-1 gap-6">
                <p>
                  {product.campaign} - {product.status}
                </p>
                <StatusPicker />
              </div>
              <div className="grid grid-cols-1">
                <p>handle: {product.handle}</p>
                <p>title: {product.title}</p>
                <p>description: {product.body_html}</p>
                <p>default vendor: {product.vendor}</p>
                <p>sku: {product.sku}</p>
                <p>product type: {product.product_type}</p>

                {product.status === "complete" && (
                  <Link
                    to={{
                      pathname: product.shopify_admin_url,
                    }}
                    target="_blank"
                  >
                    {product.shopify_admin_url}
                  </Link>
                )}
                {product.status === "complete" && (
                  <Link
                    to={{
                      pathname: product.shopify_store_url,
                    }}
                    target="_blank"
                  >
                    {product.shopify_store_url}
                  </Link>
                )}
              </div>

              <div>
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  Designs
                </h3>
                {product.design_templates.map(function (template, index) {
                  return (
                    <button
                      type="button"
                      onClick={() => goToDesign(template)}
                      key={index}
                    >
                      <div className="p-4 underline">
                        <p>{template}</p>
                      </div>
                    </button>
                  );
                })}
              </div>

              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Collections
              </h3>
              {product.shopify_collections ? (
                <div>
                  {product.shopify_collections.map(function (
                    collection,
                    index
                  ) {
                    return (
                      <div
                        className="border p-4 grid grid-cols-1 my-2"
                        key={index}
                      >
                        <p>{collection.handle ? collection.handle : ""}</p>
                        <p>{collection.store ? collection.store : ""}</p>
                        <p>
                          {collection.shopify_id ? collection.shopify_id : ""}
                        </p>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div>
                  <p>No Tags</p>
                </div>
              )}

              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Meta Fields
              </h3>
              {product.metafields ? (
                <div>
                  {product.metafields.map(function (meta, index) {
                    return (
                      <p key={index}>
                        {meta.namespace}.{meta.key} - {meta.value}
                      </p>
                    );
                  })}
                </div>
              ) : (
                <div>
                  <p>No Meta</p>
                </div>
              )}

              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Tags
              </h3>
              {product.tags ? (
                <div>
                  {product.tags.map(function (tag, index) {
                    return <p key={index}>{tag}</p>;
                  })}
                </div>
              ) : (
                <div>
                  <p>No Tags</p>
                </div>
              )}

              {product.variants && product.variants.length > 0 && (
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Variants
                  </h3>
                  <p>Variant Count {getVariantCount()}/100</p>
                  <VariantList />
                </div>
              )}

              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Licensing
              </h3>
              {product.licensing ? (
                <div>
                  {product.licensing.map(function (license, index) {
                    return <p key={index}>{getLicensorName(license)}</p>;
                  })}
                </div>
              ) : (
                <div>
                  <p>No Licensing</p>
                </div>
              )}
              <div>
                <p>
                  Affinity Product ID: {product.affinity_product_category_id}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
